/**
 * Returns an object with all the build data for the application to consume.
 * Anything that is prefixed with `process.env` is injected (via webpack config) as a build variable.
 */
export const buildData = {
  gitHash: process.env.GIT_COMMIT || 'unknown',
  gitBranch: process.env.GIT_TAG || 'unknown',
  gitTag: process.env.GIT_TAG || 'unknown',
};
